import React from "react";
import Provider from "./Provider.js";
export default function OppositeProvider(props) {
    const { provider } = props;
    if (!provider.value) {
        props.onProviderUpdate({
            ...provider,
            value: { type: "constant", value: 0 },
        });
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        "Odwraca znak",
        React.createElement("br", null),
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement("b", null, "-"),
            React.createElement(Provider, { provider: provider.value, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate({
                    ...provider,
                    value: newP,
                }), formatNames: props.formatNames }))));
}
